import React, {lazy} from 'react'

const Login = lazy(() => import('./views/auth/Login'))
const Register = lazy(() => import('./views/auth/Register'))
const FindId = lazy(() => import('./views/auth/FindId'))

const Home = lazy(() => import('./views/home/Home'))
const Tiles = lazy(() => import('./views/home/Tiles'))
const Detail = lazy(() => import('./views/home/Detail'))

const Mypage = lazy(() => import('./views/mypage/Mypage'))
const Cart = lazy(() => import('./views/mypage/Cart'))
const WishList = lazy(() => import('./views/mypage/WishList'))
const Paybag = lazy(() => import('./views/mypage/Paybag'))
const PaybagRequest = lazy(() => import('./views/mypage/PaybagRequest'))
const Coupon = lazy(() => import('./views/mypage/Coupon'))

const MemberInfo = lazy(() => import('./views/mypage/MemberInfo'))
const MemExit = lazy(() => import('./views/mypage/MemExit'))
const MemberLV = lazy(() => import('./views/mypage/MemberLV'))
const MaterialFinderList = lazy(() => import('./views/MaterialFinder/List'))

const RequestList = lazy(() => import('./views/mypage/RequestList'))
const SampleRequest = lazy(() => import('./views/request/sample'))
const BuyRequest = lazy(() => import('./views/request/buy'))

const Inquiry = lazy(() => import('./views/mypage/Inquiry'))
const Faq = lazy(() => import('./views/mypage/Faq'))

const Privacy = lazy(() => import('./views/terms/Privacy'))

const routes = [
  { path: '/', exact: true, name: 'Home' },
  { path: '/login', name: 'Login', element: Login },
  { path: '/register', name: 'Register', element: Register },
  { path: '/find-idpw', name: 'FindId', element: FindId },

  { path: '/home', name: 'Home', element: Home },
  { path: '/tiles', name: 'Tiles', element: Tiles },
  { path: '/detail', name: 'Detail', element: Detail },
  { path: '/detail/:id', name: 'Detail', element: Detail },

  { path: '/mypage', name: 'Mypage', element: Mypage },
  { path: '/cart', name: 'Cart', element: Cart },
  { path: '/wish-list', name: 'WishList', element: WishList },
  { path: '/cart', name: 'Cart', element: WishList },
  { path: '/paybag', name: 'Paybag', element: Paybag },
  { path: '/paybag-request', name: 'PaybagRequest', element: PaybagRequest },
  // { path: '/coupon', name: 'Coupon', element: Coupon },

  { path: '/memberinfo', name: 'MemberInfo', element: MemberInfo },
  { path: '/member-exit', name: 'MemExit', element: MemExit },
  { path: '/memberlv', name: 'MemberLV', element: MemberLV },

  { path: '/search', name: 'MaterialSearch', element: MaterialFinderList },
  { path: '/request-list', name: 'RequestList', element: RequestList },
  { path: '/request/sample', name: 'SampleRequest', element: SampleRequest },
  { path: '/request/buy', name: 'BuyRequest', element: BuyRequest },
  { path: '/terms/privacy', name: 'Privacy', element: Privacy },

  // { path: '/inquiry', name: 'Inquiry', element: Inquiry },
  { path: '/faq', name: 'Faq', element: Faq },
]

export default routes
